"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader } from "lucide-react";
export default function ClaimYourStage() {
  return <section data-section-id="259787" id="join-the-bloom-club" className="dark bg-background text-foreground relative flex min-h-[80vh] items-center justify-center overflow-hidden px-4 py-24 sm:py-32">
      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none">
        <div className="h-[600px] w-[600px] rounded-lg bg-primary/10 blur-[120px] opacity-40 mix-blend-screen"></div>
      </div>

      {}
      <div className="absolute inset-0 z-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/crushed-velvet.png')] opacity-[0.08] pointer-events-none"></div>

      <div className="relative z-10 w-full max-w-2xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-serif text-4xl md:text-6xl font-medium tracking-tight bg-clip-text text-transparent bg-gradient-to-b from-foreground to-foreground/70 drop-shadow-sm mb-4">
            Join the Bloom Club
          </h2>
          <p className="font-default text-muted-foreground text-lg md:text-xl max-w-xl mx-auto">
            Receive seasonal garden updates and exclusive floral artistry tips.
          </p>
        </div>

        <div className="bg-card/20 backdrop-blur-md border border-white/5 p-6 sm:p-10 rounded-md shadow-xl shadow-black/20">
          <FormProvider formKey="bloom_club_signup_home" formId="bloom_club_signup_home" sectionName="ClaimYourStage" defaultValues={{
          artist_name: "",
          email: "",
          genre: "",
          website: "",
          bio: ""
        }} validationRules={{
          artist_name: {
            required: true
          },
          email: {
            required: true,
            pattern: "email"
          },
          genre: {
            required: true
          },
          website: {
            pattern: "url"
          },
          bio: {
            maxLength: 300
          }
        }} submitText="Subscribe" successMessage="Welcome to the Bloom Club. Your floral journey begins now.">
            <ClaimStageForm />
          </FormProvider>
        </div>
      </div>
    </section>;
}
function ClaimStageForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  const sharedInputClasses = "flex w-full min-w-0 rounded-md border-b border-t-0 border-x-0 border-input bg-transparent px-3 py-2 text-base shadow-sm transition-all outline-none placeholder:text-muted-foreground/50 focus-visible:border-primary focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm aria-invalid:border-destructive";
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center space-y-6 animate-in fade-in zoom-in duration-500">
        <div className="h-16 w-16 rounded-md bg-primary/10 flex items-center justify-center mb-4">
          <svg className="w-8 h-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <h3 className="font-serif text-2xl font-medium text-foreground">Welcome to PETAL</h3>
        <p className="font-default text-muted-foreground text-lg">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4 border-primary/20 hover:bg-primary/10 rounded-md">
          Join Again
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="artist_name" rules={{
        required: "Full Name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default text-foreground/70 uppercase tracking-widest text-[10px]">Full Name</FormLabel>
              <FormControl>
                <Input placeholder="Evelyn Rose" className="bg-transparent border-b border-t-0 border-x-0 border-white/20 focus-visible:ring-0 focus-visible:border-primary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email Address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default text-foreground/70 uppercase tracking-widest text-[10px]">Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="hello@petal.com" className="bg-transparent border-b border-t-0 border-x-0 border-white/20 focus-visible:ring-0 focus-visible:border-primary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="genre" rules={{
        required: "Please select an interest"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default text-foreground/70 uppercase tracking-widest text-[10px]">Interest</FormLabel>
              <FormControl>
                <select className={`${sharedInputClasses} h-9 bg-transparent border-b border-t-0 border-x-0 border-white/20 rounded-none focus-visible:ring-0 focus-visible:border-primary appearance-none`} {...field}>
                  <option value="" disabled className="bg-background text-muted-foreground">Select interest</option>
                  {["Seasonal Bouquets", "Potted Plants", "Event Floral", "Garden Workshops", "Bespoke Artistry"].map(genre => <option key={genre} value={genre} className="bg-background text-foreground">
                      {genre}
                    </option>)}
                </select>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="website" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default text-foreground/70 uppercase tracking-widest text-[10px]">Social Handle</FormLabel>
              <FormControl>
                <Input type="url" placeholder="@petal_garden" className="bg-transparent border-b border-t-0 border-x-0 border-white/20 focus-visible:ring-0 focus-visible:border-primary" {...field} />
              </FormControl>
              <FormDescription className="text-[10px] text-muted-foreground/50 uppercase tracking-wider">Share your garden inspiration</FormDescription>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="bio" rules={{
      maxLength: {
        value: 300,
        message: "Message must be less than 300 characters"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default text-foreground/70 uppercase tracking-widest text-[10px]">A Note to Us</FormLabel>
            <FormControl>
              <textarea placeholder="Tell us about your favorite blooms..." className={`${sharedInputClasses} min-h-[100px] resize-y bg-transparent border-b border-t-0 border-x-0 border-white/20 rounded-none focus-visible:ring-0 focus-visible:border-primary`} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md text-center">
          <p className="text-destructive text-sm font-medium">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} size="lg" className="w-full h-14 text-sm font-medium tracking-widest uppercase bg-muted hover:bg-muted/80 text-muted-foreground transition-all duration-500 rounded-md shadow-md">
        {isSubmitting ? <>
            <Loader className="mr-2 h-4 w-4 animate-spin" />
            Cultivating...
          </> : "Subscribe"}
      </Button>
    </Form>;
}